export default __webpack_public_path__ + "static/media/fried-cauliflower.c1432843.png";